"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styleTypes = require("./styleTypes");

exports.default = {
  componentName: "header",
  cms: {
    style: {
      background: "Background",
      navColor: "Nav link color",
      navHoverColor: "Hover color",
      navFont: "Font size",
      textTransform: "Text transform",
      fontWeight: "Font weight"
    },
    links: {
      link1: "Link 1",
      // url1: "Url",
      link2: "Link 2",
      // url2: "Url",
      link3: "Link 3"
      // url3: "Url ",
    },
    media: {
      logo: "Logo url",
      logoAlt: "Brand image alt"
    }
  },
  styleType: {
    style: {
      background: { type: "color" },
      navColor: { type: "color" },
      navHoverColor: { type: "color" },
      navFont: _extends({}, _styleTypes.navFontSize),
      textTransform: _extends({}, _styleTypes.linkTextTransform),
      fontWeight: _extends({}, _styleTypes.linkFontWeight)
    },
    content: {},
    media: {
      logo: "Logo url",
      logoAlt: "Brand image alt"
    }
  },
  props: {
    //editable part
    style: {
      background: "#36444f",
      navColor: "#fff",
      navHoverColor: "red",
      navFont: "16px",
      textTransform: "capitalize",
      fontWeight: "500"
    },
    links: {
      link1: "Home",
      // url1: "",
      link2: "About",
      // url2: "",
      link3: "join Us"
      // url3: "",
    },
    media: {
      logo: "https://elitemarketingpro.com/go/wp-content/uploads/2016/10/Dummy-logo-white.png",
      logoAlt: "logo"
    }
  }
};